export default __webpack_public_path__ + "static/media/jwl-1.33428ef8.png";